import React from "react"
import styled, { css } from "styled-components"
import { Chevron } from "@components/icons"
import {
  Button,
  Label,
  CountWrapper,
  Count,
  IconWrapper,
  ExpandableContainer,
} from "@components/MenuItem/common"
import MenuItemCheckbox, {
  MenuItemCheckboxProps,
} from "@components/MenuItemCheckbox"

const Container = styled.div``

export const anchorItemStyles = css`
  width: 100%;
  height: 36px;
`

interface MenuItemAccordionCheckboxProps {
  label: string
  items: Array<MenuItemCheckboxProps>
  activeItemCount: number
}

const MenuItemAccordionCheckbox: React.FC<MenuItemAccordionCheckboxProps> = ({
  label,
  items,
  activeItemCount,
}) => {
  const anchorRef = React.useRef<HTMLDivElement>(null)
  const [expanded, setExpanded] = React.useState<boolean>(true)

  const toggleExpanded = () => {
    setExpanded(!expanded)
  }

  return (
    <Container ref={anchorRef}>
      <Button onClick={toggleExpanded}>
        <Label>{label}</Label>
        {activeItemCount > 0 && (
          <CountWrapper>
            <Count>{activeItemCount}</Count>
          </CountWrapper>
        )}
        <IconWrapper rotate={expanded ? 180 : 0}>
          <Chevron />
        </IconWrapper>
      </Button>
      <ExpandableContainer expanded={expanded}>
        {items.map((item, i) => (
          <MenuItemCheckbox key={`${i}-${item.label}`} {...item} />
        ))}
      </ExpandableContainer>
    </Container>
  )
}

export default MenuItemAccordionCheckbox
